// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input.text-input.text-input-md {
  margin: 0px !important;
  padding: 10px !important;
  background-color: white !important;
  width: 100% !important;
  border-radius: 5px !important;
}

.error-text {
  color: #f53d3d;
}

button.disable-hover.button.button-ios.button-default.button-default-md {
  border-radius: 2px;
  overflow: hidden;
  font-size: 1.4rem;
  font-weight: 500;
  text-transform: uppercase;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

button.disable-hover.button.button-ios.button-default.button-default-ios {
  border-radius: 2px;
  overflow: hidden;
  font-size: 1.4rem;
  font-weight: 500;
  text-transform: uppercase;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

label {
  font-size: 14px;
  color: white;
  margin: 15px 0px;
}

input {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  height: 36px;
}

.text-input-ios {
  border: 1px solid #e0e0e0 !important;
  border-radius: 4px !important;
  height: 36px;
  background-color: #fff !important;
  padding-left: 10px !important;
  margin: 0px !important;
}

input#graduationyear_input {
  padding-left: 15px !important;
}

input#birthDate_input {
  padding-left: 15px;
}

.toolbar-background-md {
  background-color: #be1e2d;
}

.toolbar-background-ios {
  background-color: #be1e2d;
}

.toolbar-title {
  font-size: 16px;
  color: white;
}

.close-btn {
  color: white;
}

.ejPicker {
  font-size: 14px;
  padding: 0px;
}

.ejPicker input {
  margin-left: -7px !important;
}

.ejPicker ej-datepicker {
  border-bottom: none !important;
  padding-left: 5px !important;
}

.ejPicker ej-datepicker:focus {
  border-bottom: none !important;
}

.footer {
  padding: 6px 15px 10px 20px;
  background: #6c6d71;
}

.grid {
  background-color: #6c6d71;
}

.files {
  max-height: 150px;
  overflow: auto;
}

.filelist {
  float: left !important;
  background: #e0e0e0;
  padding: 5px 10px 5px 10px;
  border-radius: 13px;
  font-weight: normal !important;
  color: black !important;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.profileimage {
  height: 150px;
  width: 150px;
  border-radius: 50%;
  object-fit: cover;
}

button:hover {
  opacity: 0.7 !important;
}

.e-input-group {
  width: 100% !important;
  border-width: 1px 1px 1px 1px !important;
  border: 2px solid #efefef !important;
  border-radius: 5px !important;
  height: 40px !important;
  background: white !important;
}

#sports_position_codes .e-input-group {
  height: 40px !important;
  padding: 5px 10px;
  padding-right: 0px;
}

.e-multiselect .e-input-group-icon.e-ddl-icon {
  font-size: 10px;
  opacity: 0.6;
}

.e-numeric.e-control-wrapper.e-input-group .e-input-group-icon {
  font-size: 10px;
  opacity: 0.6;
  margin-right: 0px;
  padding-top: 0px;
}

.e-input-group input.e-input,
.e-input-group input,
.e-input-group.e-control-wrapper input.e-input,
.e-input-group.e-control-wrapper input {
  padding-left: 10px;
  padding-top: 10px;
}

.e-input-group input.e-input:focus,
.e-input-group.e-control-wrapper input.e-input:focus {
  padding-left: 10px;
  padding-top: 10px;
}

.inches {
  padding: 0px 0px 0px 10px;
}

@media only screen and (max-width: 764px) {
  .inches {
    width: 95px;
  }
  .feet {
    padding: 0px 0px 0px 27px;
    width: 100px;
  }
  .dropdown {
    padding-right: 0px;
  }
}
.text-md-danger {
  margin: auto;
  margin-top: 5px;
  padding-top: 3px;
  font-size: 14px !important;
}

.height-label {
  flex-wrap: nowrap;
}

@media only screen and (max-width: 425px) {
  label {
    float: left !important;
  }
  input {
    width: 100%;
  }
  .height-label {
    flex-wrap: wrap;
  }
  .dropdown {
    padding-right: 5px !important;
  }
}
.e-multiselect.e-input-group.e-input-focus {
  height: auto !important;
}

.e-multi-select-wrapper {
  padding-left: 5px;
}

.ng-untouched.ng-pristine.ng-valid {
  padding-left: 0px;
}

.ng-valid.ng-dirty.ng-touched {
  padding-left: 0px;
}

@media screen and (max-width: 768px) {
  .ng-valid.ng-dirty.ng-touched {
    font-family: "Roboto", "Segoe UI", "GeezaPro", "DejaVu Serif", "sans-serif";
    font-size: 14px !important;
    font-weight: normal !important;
  }
  .ng-untouched.ng-pristine.ng-valid {
    font-family: "Roboto", "Segoe UI", "GeezaPro", "DejaVu Serif", "sans-serif";
    font-size: 14px !important;
    font-weight: normal !important;
  }
}
.uploadButton {
  background-color: #be1e2d;
  height: 30px;
  margin: 95px 0 0 2px;
  padding: 7px 0 0 16px;
  text-transform: uppercase;
  width: 85px;
  font-weight: 500;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.uploadButtonMobile {
  background-color: #be1e2d;
  height: 30px;
  margin: 60px 0 0 2px;
  padding: 7px 0 0 16px;
  width: 85px;
  border-radius: 2px;
  overflow: hidden;
  font-size: 1.4rem;
  font-weight: 500;
  text-transform: uppercase;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

#sportsposition span.dropdown-btn {
  background: #fff;
  min-height: 34px !important;
  font-size: 14px;
  border: 1px solid #adadad;
}

#sportsposition span {
  color: #adadad;
}

#sportsposition .dropdown-list {
  font-size: 14px;
}

#sportsposition span.selected-item {
  background: gray !important;
  color: #fff !important;
  border: 1px solid gray;
  border-radius: 5px;
}

input[type=checkbox] + div:before {
  border: 2px solid #be1e2d !important;
}

input[type=checkbox]:disabled + div:before {
  border-color: #ccc !important;
}

input[type=checkbox]:checked + div:before {
  background: #be1e2d !important;
  border: 2px solid #be1e2d !important;
}

.multiSelectDisabled {
  pointer-events: none;
}

.multiSelectActive {
  pointer-events: unset;
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .Update_Profile_Info .modal-wrapper {
    top: 0 !important;
  }
}
.toolbar-title {
  font-size: 16px;
  color: white;
}

.inputItem {
  margin-top: 8px;
  color: #000000;
  font-size: 14px;
  background: white;
  border: 2px solid #efefef;
  border-radius: 5px;
  height: 40px;
}

.multiselect-dropdown .dropdown-btn {
  border: 1px solid white !important;
}
.multiselect-dropdown .dropdown-btn .selected-item {
  border: 1px solid gray;
  background: gray;
}

.button-section {
  background-color: #6c6d71;
  padding: 5px;
  width: 100%;
  float: right;
}
.button-section .done-btn {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  color: white;
  border-radius: 3px;
  height: 30px;
  width: 60px;
  float: right;
  background-color: rgb(190, 30, 45);
  margin: 5px;
}
.button-section .cancel-btn {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  margin: 5px;
  background-color: transparent;
  color: white;
  height: 30px;
  width: 70px;
  float: right;
}

.upload-btn {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  background-color: rgb(190, 30, 45);
  height: 40px;
  width: 100px;
  color: white;
  font-size: 15px;
}

.e-popup.e-multi-select-list-wrapper {
  padding-top: calc(1px + env(safe-area-inset-top)) !important;
}

::ng-deep .update-athlete-popover {
  --width: 100%;
  --max-width: 587px;
}
::ng-deep .update-athlete-popover .popover-viewport.sc-ion-popover-ios {
  overflow-y: auto;
}
::ng-deep .update-athlete-popover ion-item {
  --inner-border-width: 0;
  --background: #ffffff;
  background: #ffffff;
  color: #000000;
  font-size: 13px !important;
  height: 36px;
  --background-focused-opacity: 0.08 !important;
  --background-hover-opacity: 0.08 !important;
}
::ng-deep .update-athlete-popover ion-item ion-label {
  color: #000000 !important;
}
::ng-deep .update-athlete-popover ion-item ion-radio {
  --color-checked:#be1e2d!important;
}

::ng-deep .update-athleteheightfeet-popover {
  --width: 100%;
  --max-width: 287px;
}
::ng-deep .update-athleteheightfeet-popover .popover-viewport.sc-ion-popover-ios {
  overflow-y: auto;
}
::ng-deep .update-athleteheightfeet-popover ion-item {
  --inner-border-width: 0;
  --background: #ffffff;
  background: #ffffff;
  color: #000000;
  font-size: 13px !important;
  height: 36px;
  --background-focused-opacity: 0.08 !important;
  --background-hover-opacity: 0.08 !important;
}
::ng-deep .update-athleteheightfeet-popover ion-item ion-label {
  color: #000000 !important;
}
::ng-deep .update-athleteheightfeet-popover ion-item ion-radio {
  --color-checked:#be1e2d!important;
}

::ng-deep .training-center-popover {
  --width: 100%;
  --max-width: 587px;
}
::ng-deep .training-center-popover .popover-viewport.sc-ion-popover-ios {
  overflow-y: auto;
}
::ng-deep .training-center-popover ion-item {
  --inner-border-width: 0;
  --background: #ffffff;
  background: #ffffff;
  --color: #000000;
  color: #000000;
  font-size: 13px !important;
  height: 36px;
  --background-focused-opacity: 0.08 !important;
  --background-hover-opacity: 0.08 !important;
}
::ng-deep .training-center-popover ion-item ion-label {
  color: #000000 !important;
  --color: #000000 !important;
}
::ng-deep .training-center-popover ion-item ion-radio {
  --color-checked:#be1e2d!important;
}

ion-select::part(text) {
  margin-left: 10px !important;
}

ion-select {
  padding-left: 0px !important;
}

ion-select.select-text::part(text) {
  margin-left: 10px !important;
}

.tool-bar {
  background: #BE1E2D;
  --background: #BE1E2D;
  border-bottom: 2px solid #c2c2c2;
  color: white;
}

ion-modal {
  --width: 100% !important;
}

ion-toolbar .centerButtons button {
  width: 35px;
}

ion-toolbar .centerButtons {
  text-align: center;
}

.cropperClose .closeIcon {
  top: inherit !important;
}

ion-button {
  width: auto;
  height: auto;
  --background: transparent;
  --box-shadow: none;
}

ion-button::part(native) {
  padding: 0px 5px !important;
}

.cropperContent ion-icon {
  color: #fff;
}

.cropperContent img {
  max-width: 100%;
  max-height: 100%;
}

.toolbar-save {
  height: 55px;
  background-color: #222428;
  padding: 10px 0px;
  text-align: end;
  min-height: 55px;
}

.toolbar-edit {
  height: 55px;
  padding: 5px 0px;
  background-color: #222428;
  text-align: center;
  min-height: 55px;
  color: #fff;
  width: 100%;
  bottom: 0px;
}

.toolbar-save ion-icon {
  color: #BE1E2D !important;
  font-weight: bold;
  font-size: 25px !important;
}

.toolbar-edit ion-icon {
  color: #fff;
  font-weight: bold;
  font-size: 25px !important;
}

@media screen and (max-width: 556px) {
  ::ng-deep .update-athlete-popover {
    --max-width:507px;
    margin-left: 10px;
  }
}
@media screen and (max-width: 556px) {
  ::ng-deep .update-athleteheightfeet-popover {
    --max-width: 252px;
    margin-left: 8px;
  }
}
@media screen and (max-width: 556px) {
  ::ng-deep .training-center-popover {
    --max-width: 507px;
    margin-left: 10px;
  }
}
::ng-deep .update-athlete-popovermobile {
  transform-origin: right top !important;
  --width: 97%;
  --background: #ffffff;
}
::ng-deep .update-athlete-popovermobile .popover-viewport.sc-ion-popover-ios {
  overflow-y: auto;
}
::ng-deep .update-athlete-popovermobile ion-item {
  --inner-border-width: 0;
  --background: #ffffff;
  background: #ffffff;
  color: #000000;
  font-size: 13px !important;
  height: 36px;
  --background-focused-opacity: 0.08 !important;
  --background-hover-opacity: 0.08 !important;
}
::ng-deep .update-athlete-popovermobile ion-item ion-label {
  color: #000000 !important;
}
::ng-deep .update-athlete-popovermobile ion-item ion-radio {
  --color-checked:#be1e2d!important;
}

::ng-deep .training-center-popovermobile {
  transform-origin: right top !important;
  --width: 97%;
  --background: #ffffff;
}
::ng-deep .training-center-popovermobile .popover-viewport.sc-ion-popover-ios {
  overflow-y: auto;
}
@media screen and (device-aspect-ratio: 375/667) {
  ::ng-deep .training-center-popovermobile .popover-content {
    top: auto !important;
    bottom: 14% !important;
    height: 80%;
  }
}
@media screen and (device-aspect-ratio: 40/71) {
  ::ng-deep .training-center-popovermobile .popover-content {
    top: auto !important;
    bottom: 17% !important;
    height: 80%;
  }
}
::ng-deep .training-center-popovermobile ion-item {
  --inner-border-width: 0;
  --background: #ffffff;
  background: #ffffff;
  --color: #000000;
  color: #000000;
  font-size: 13px !important;
  height: 36px;
  --background-focused-opacity: 0.08 !important;
  --background-hover-opacity: 0.08 !important;
}
::ng-deep .training-center-popovermobile ion-item ion-label {
  color: #000000 !important;
  --color: #000000 !important;
}
::ng-deep .training-center-popovermobile ion-item ion-radio {
  --color-checked:#be1e2d!important;
}

.e-multiselect .e-down-icon .e-chips-close.e-close-hooker {
  margin-top: -26px !important;
  padding-left: 5px;
}

.e-multi-select-wrapper .e-delim-values {
  line-height: 30px !important;
}

.e-checkbox .e-multi-select-wrapper .e-delim-values .e-remain {
  padding-left: 5px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/update-athlete-info/update-athlete-info.page.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,wBAAA;EACA,kCAAA;EACA,sBAAA;EACA,6BAAA;AACJ;;AACA;EACI,cAAA;AAEJ;;AACA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,+GAAA;AAEJ;;AACA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,+GAAA;AAEJ;;AACA;EACI,eAAA;EACA,YAAA;EACA,gBAAA;AAEJ;;AACA;EACI,yBAAA;EACA,kBAAA;EACA,YAAA;AAEJ;;AACA;EACI,oCAAA;EACA,6BAAA;EACA,YAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;AAEJ;;AACA;EACI,6BAAA;AAEJ;;AACA;EACI,kBAAA;AAEJ;;AACA;EACI,yBAAA;AAEJ;;AACA;EACI,yBAAA;AAEJ;;AACA;EACI,eAAA;EACA,YAAA;AAEJ;;AACA;EACI,YAAA;AAEJ;;AACA;EACI,eAAA;EACA,YAAA;AAEJ;;AACA;EACI,4BAAA;AAEJ;;AACA;EACI,8BAAA;EACA,4BAAA;AAEJ;;AACA;EACI,8BAAA;AAEJ;;AACA;EACI,2BAAA;EACA,mBAAA;AAEJ;;AACA;EACI,yBAAA;AAEJ;;AACA;EACI,iBAAA;EACA,cAAA;AAEJ;;AACA;EACI,sBAAA;EACA,mBAAA;EACA,0BAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;AAEJ;;AACA;;EAEI,wBAAA;EACA,SAAA;AAEJ;;AACA;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAEJ;;AACA;EACI,uBAAA;AAEJ;;AACA;EACI,sBAAA;EACA,wCAAA;EACA,oCAAA;EACA,6BAAA;EACA,uBAAA;EACA,4BAAA;AAEJ;;AACA;EACI,uBAAA;EACA,iBAAA;EACA,kBAAA;AAEJ;;AACA;EACI,eAAA;EACA,YAAA;AAEJ;;AACA;EACI,eAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAEJ;;AAAA;;;;EAII,kBAAA;EACA,iBAAA;AAGJ;;AAAA;;EAEI,kBAAA;EACA,iBAAA;AAGJ;;AAKA;EACI,yBAAA;AAFJ;;AAKA;EACI;IACI,WAAA;EAFN;EAKE;IACI,yBAAA;IACA,YAAA;EAHN;EAME;IACI,kBAAA;EAJN;AACF;AAOA;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AALJ;;AAQA;EACI,iBAAA;AALJ;;AAQA;EACI;IACI,sBAAA;EALN;EAQE;IACI,WAAA;EANN;EASE;IACI,eAAA;EAPN;EAUE;IACI,6BAAA;EARN;AACF;AAWA;EACI,uBAAA;AATJ;;AAYA;EACI,iBAAA;AATJ;;AAYA;EACI,iBAAA;AATJ;;AAYA;EACI,iBAAA;AATJ;;AAYA;EACI;IACI,2EAAA;IACA,0BAAA;IACA,8BAAA;EATN;EAYE;IACI,2EAAA;IACA,0BAAA;IACA,8BAAA;EAVN;AACF;AAaA;EACI,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EAGA,+GAAA;AAZJ;;AAeA;EACI,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EAGA,+GAAA;AAbJ;;AAgBA;EACI,gBAAA;EACA,2BAAA;EACA,eAAA;EACA,yBAAA;AAbJ;;AAgBA;EACI,cAAA;AAbJ;;AAgBA;EACI,eAAA;AAbJ;;AAgBA;EACI,2BAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;AAbJ;;AAgBA;EACI,oCAAA;AAbJ;;AAeA;EACI,6BAAA;AAZJ;;AAeA;EACI,8BAAA;EACA,oCAAA;AAZJ;;AAeA;EACI,oBAAA;AAZJ;;AAeA;EACI,qBAAA;AAZJ;;AAeA;EACI;IACI,iBAAA;EAZN;AACF;AAeA;EACI,eAAA;EACA,YAAA;AAbJ;;AAgBA;EACI,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAbJ;;AAiBI;EACI,kCAAA;AAdR;AAeQ;EACI,sBAAA;EACA,gBAAA;AAbZ;;AAkBA;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAfJ;AAiBI;EACI,+GAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,WAAA;AAfR;AAkBI;EACI,+GAAA;EACA,WAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAhBR;;AAoBA;EACI,+GAAA;EACA,kCAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAjBJ;;AAoBA;EACI,4DAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,kBAAA;AAjBJ;AAkBI;EACI,gBAAA;AAhBR;AAmBI;EACI,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;EACA,YAAA;EACA,6CAAA;EACA,2CAAA;AAjBR;AAmBQ;EACI,yBAAA;AAjBZ;AAmBQ;EACI,iCAAA;AAjBZ;;AAsBA;EACI,aAAA;EACA,kBAAA;AAnBJ;AAoBI;EACI,gBAAA;AAlBR;AAqBI;EACI,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;EACA,YAAA;EACA,6CAAA;EACA,2CAAA;AAnBR;AAqBQ;EACI,yBAAA;AAnBZ;AAqBQ;EACI,iCAAA;AAnBZ;;AAyBA;EACI,aAAA;EACA,kBAAA;AAtBJ;AAuBI;EACI,gBAAA;AArBR;AAwBI;EACI,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,YAAA;EACA,6CAAA;EACA,2CAAA;AAtBR;AAwBQ;EACI,yBAAA;EACA,2BAAA;AAtBZ;AAwBQ;EACI,iCAAA;AAtBZ;;AA4BA;EACI,4BAAA;AAzBJ;;AA4BA;EACI,4BAAA;AAzBJ;;AA4BA;EACI,4BAAA;AAzBJ;;AA4BA;EACI,mBAAA;EACA,qBAAA;EACA,gCAAA;EACA,YAAA;AAzBJ;;AA4BA;EACI,wBAAA;AAzBJ;;AA6BA;EACI,WAAA;AA1BJ;;AA6BA;EACI,kBAAA;AA1BJ;;AA6BA;EACI,uBAAA;AA1BJ;;AA6BA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AA1BJ;;AA6BA;EACI,2BAAA;AA1BJ;;AA6BA;EACG,WAAA;AA1BH;;AA6BA;EACG,eAAA;EACA,gBAAA;AA1BH;;AA6BA;EACI,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AA1BJ;;AA6BA;EACI,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,WAAA;EACA,WAAA;EACA,WAAA;AA3BJ;;AA8BA;EACI,yBAAA;EACA,iBAAA;EACA,0BAAA;AA3BJ;;AA6BA;EACI,WAAA;EACA,iBAAA;EACA,0BAAA;AA1BJ;;AA+BA;EACI;IACI,iBAAA;IACA,iBAAA;EA5BN;AACF;AA+BA;EACI;IACI,kBAAA;IACA,gBAAA;EA7BN;AACF;AAgCA;EACI;IACI,kBAAA;IACA,iBAAA;EA9BN;AACF;AAiCA;EACI,sCAAA;EACA,YAAA;EACA,qBAAA;AA/BJ;AAgCI;EACI,gBAAA;AA9BR;AAiCI;EACI,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;EACA,YAAA;EACC,6CAAA;EACD,2CAAA;AA/BR;AAgCQ;EACI,yBAAA;AA9BZ;AAgCQ;EACI,iCAAA;AA9BZ;;AAoCA;EACI,sCAAA;EACA,YAAA;EACA,qBAAA;AAjCJ;AAkCI;EACI,gBAAA;AAhCR;AAmCI;EACI;IACI,oBAAA;IACA,sBAAA;IACA,WAAA;EAjCV;AACF;AAoCI;EACI;IACI,oBAAA;IACA,sBAAA;IACA,WAAA;EAlCV;AACF;AAqCI;EACI,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,YAAA;EACA,6CAAA;EACA,2CAAA;AAnCR;AAqCQ;EACI,yBAAA;EACA,2BAAA;AAnCZ;AAqCQ;EACI,iCAAA;AAnCZ;;AAwCA;EACC,4BAAA;EACG,iBAAA;AArCJ;;AAwCA;EACI,4BAAA;AArCJ;;AAwCA;EACI,4BAAA;AArCJ","sourcesContent":["input.text-input.text-input-md {\n    margin: 0px !important;\n    padding: 10px !important;\n    background-color: white !important;\n    width: 100% !important;\n    border-radius: 5px !important;\n}\n.error-text{\n    color: #f53d3d;\n}\n\nbutton.disable-hover.button.button-ios.button-default.button-default-md {\n    border-radius: 2px;\n    overflow: hidden;\n    font-size: 1.4rem;\n    font-weight: 500;\n    text-transform: uppercase;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n}\n\nbutton.disable-hover.button.button-ios.button-default.button-default-ios {\n    border-radius: 2px;\n    overflow: hidden;\n    font-size: 1.4rem;\n    font-weight: 500;\n    text-transform: uppercase;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n}\n\nlabel {\n    font-size: 14px;\n    color: white;\n    margin: 15px 0px;\n}\n\ninput {\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n    height: 36px;\n}\n\n.text-input-ios {\n    border: 1px solid #e0e0e0 !important;\n    border-radius: 4px !important;\n    height: 36px;\n    background-color: #fff !important;\n    padding-left: 10px !important;\n    margin: 0px !important;\n}\n\ninput#graduationyear_input {\n    padding-left: 15px !important;\n}\n\ninput#birthDate_input {\n    padding-left: 15px;\n}\n\n.toolbar-background-md {\n    background-color: #be1e2d;\n}\n\n.toolbar-background-ios {\n    background-color: #be1e2d;\n}\n\n.toolbar-title {\n    font-size: 16px;\n    color: white;\n}\n\n.close-btn {\n    color: white;\n}\n\n.ejPicker {\n    font-size: 14px;\n    padding: 0px;\n}\n\n.ejPicker input {\n    margin-left: -7px !important;\n}\n\n.ejPicker ej-datepicker {\n    border-bottom: none !important;\n    padding-left: 5px !important;\n}\n\n.ejPicker ej-datepicker:focus {\n    border-bottom: none !important;\n}\n\n.footer {\n    padding: 6px 15px 10px 20px;\n    background: #6c6d71;\n}\n\n.grid {\n    background-color: #6c6d71;\n}\n\n.files {\n    max-height: 150px;\n    overflow: auto;\n}\n\n.filelist {\n    float: left !important;\n    background: #e0e0e0;\n    padding: 5px 10px 5px 10px;\n    border-radius: 13px;\n    font-weight: normal !important;\n    color: black !important;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.profileimage {\n    height: 150px;\n    width: 150px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\nbutton:hover {\n    opacity: 0.7 !important;\n}\n\n.e-input-group {\n    width: 100% !important;\n    border-width: 1px 1px 1px 1px !important;\n    border: 2px solid #efefef !important;\n    border-radius: 5px !important;\n    height: 40px !important;\n    background: white !important;\n}\n\n#sports_position_codes .e-input-group {\n    height: 40px !important;\n    padding: 5px 10px;\n    padding-right: 0px ;\n}\n\n.e-multiselect .e-input-group-icon.e-ddl-icon{\n    font-size: 10px ;\n    opacity: 0.6;\n}\n\n.e-numeric.e-control-wrapper.e-input-group .e-input-group-icon{\n    font-size: 10px;\n    opacity: 0.6;\n    margin-right: 0px;\n    padding-top: 0px;\n}\n.e-input-group input.e-input,\n.e-input-group input,\n.e-input-group.e-control-wrapper input.e-input,\n.e-input-group.e-control-wrapper input {\n    padding-left: 10px;\n    padding-top: 10px;\n}\n\n.e-input-group input.e-input:focus,\n.e-input-group.e-control-wrapper input.e-input:focus {\n    padding-left: 10px;\n    padding-top: 10px;\n}\n\n.e-input-group.e-control-wrapper .e-input-group-icon:last-child {\n   // margin-right: 6px !important;\n   // padding-top: 6px !important;\n}\n\n.inches {\n    padding: 0px 0px 0px 10px;\n}\n\n@media only screen and (max-width: 764px) {\n    .inches {\n        width: 95px;\n    }\n\n    .feet {\n        padding: 0px 0px 0px 27px;\n        width: 100px;\n    }\n\n    .dropdown {\n        padding-right: 0px;\n    }\n}\n\n.text-md-danger {\n    margin: auto;\n    margin-top: 5px;\n    padding-top: 3px;\n    font-size: 14px !important;\n}\n\n.height-label {\n    flex-wrap: nowrap;\n}\n\n@media only screen and (max-width: 425px) {\n    label {\n        float: left !important;\n    }\n\n    input {\n        width: 100%;\n    }\n\n    .height-label {\n        flex-wrap: wrap;\n    }\n\n    .dropdown {\n        padding-right: 5px !important;\n    }\n}\n\n.e-multiselect.e-input-group.e-input-focus {\n    height: auto !important;\n}\n\n.e-multi-select-wrapper {\n    padding-left: 5px;\n}\n\n.ng-untouched.ng-pristine.ng-valid {\n    padding-left: 0px;\n}\n\n.ng-valid.ng-dirty.ng-touched {\n    padding-left: 0px;\n}\n\n@media screen and (max-width: 768px) {\n    .ng-valid.ng-dirty.ng-touched {\n        font-family: \"Roboto\", \"Segoe UI\", \"GeezaPro\", \"DejaVu Serif\", \"sans-serif\";\n        font-size: 14px !important;\n        font-weight: normal !important;\n    }\n\n    .ng-untouched.ng-pristine.ng-valid {\n        font-family: \"Roboto\", \"Segoe UI\", \"GeezaPro\", \"DejaVu Serif\", \"sans-serif\";\n        font-size: 14px !important;\n        font-weight: normal !important;\n    }\n}\n\n.uploadButton {\n    background-color: #be1e2d;\n    height: 30px;\n    margin: 95px 0 0 2px;\n    padding: 7px 0 0 16px;\n    text-transform: uppercase;\n    width: 85px;\n    font-weight: 500;\n    -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),\n        0 1px 5px 0 rgba(0, 0, 0, 0.12);\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n}\n\n.uploadButtonMobile {\n    background-color: #be1e2d;\n    height: 30px;\n    margin: 60px 0 0 2px;\n    padding: 7px 0 0 16px;\n    width: 85px;\n    border-radius: 2px;\n    overflow: hidden;\n    font-size: 1.4rem;\n    font-weight: 500;\n    text-transform: uppercase;\n    -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),\n        0 1px 5px 0 rgba(0, 0, 0, 0.12);\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n}\n\n#sportsposition span.dropdown-btn {\n    background: #fff;\n    min-height: 34px !important;\n    font-size: 14px;\n    border: 1px solid #adadad;\n}\n\n#sportsposition span {\n    color: #adadad;\n}\n\n#sportsposition .dropdown-list {\n    font-size: 14px;\n}\n\n#sportsposition span.selected-item {\n    background: gray !important;\n    color: #fff !important;\n    border: 1px solid gray;\n    border-radius: 5px;\n}\n\ninput[type=\"checkbox\"] + div:before {\n    border: 2px solid #be1e2d !important;\n}\ninput[type=\"checkbox\"]:disabled + div:before {\n    border-color: #ccc !important;\n}\n\ninput[type=\"checkbox\"]:checked + div:before {\n    background: #be1e2d !important;\n    border: 2px solid #be1e2d !important;\n}\n\n.multiSelectDisabled {\n    pointer-events: none;\n}\n\n.multiSelectActive {\n    pointer-events: unset;\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {\n    .Update_Profile_Info .modal-wrapper {\n        top: 0 !important;\n    }\n}\n\n.toolbar-title {\n    font-size: 16px;\n    color: white;\n}\n\n.inputItem {\n    margin-top: 8px;\n    color: #000000;\n    font-size: 14px;\n    background: white;\n    border: 2px solid #efefef;\n    border-radius: 5px;\n    height: 40px;\n}\n\n.multiselect-dropdown {\n    .dropdown-btn {\n        border: 1px solid white !important;\n        .selected-item {\n            border: 1px solid gray;\n            background: gray;\n        }\n    }\n}\n\n.button-section {\n    background-color: #6c6d71;\n    padding: 5px;\n    width: 100%;\n    float: right;\n\n    .done-btn {\n        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n        color: white;\n        border-radius: 3px;\n        height: 30px;\n        width: 60px;\n        float: right;\n        background-color: rgb(190, 30, 45);\n        margin: 5px;\n    }\n\n    .cancel-btn {\n        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n        margin: 5px;\n        background-color: transparent;\n        color: white;\n        height: 30px;\n        width: 70px;\n        float: right;\n    }\n}\n\n.upload-btn{\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n    background-color: rgb(190, 30, 45);\n    height: 40px;\n    width: 100px;\n    color : white;\n    font-size: 15px;   \n}\n\n.e-popup.e-multi-select-list-wrapper{\n    padding-top : calc(1px + env(safe-area-inset-top)) !important;\n}\n\n::ng-deep .update-athlete-popover {\n    --width: 100%;\t\n    --max-width: 587px;\n    .popover-viewport.sc-ion-popover-ios{\n        overflow-y: auto;\n    }\n    \n    ion-item{\n        --inner-border-width: 0;\n        --background: #ffffff;\n        background: #ffffff;\n        color: #000000;\n        font-size: 13px !important;\n        height: 36px;\n        --background-focused-opacity: 0.08 !important;\n        --background-hover-opacity: 0.08 !important;\n\n        ion-label{\n            color: #000000 !important;\n        }\n        ion-radio{\n            --color-checked:#be1e2d!important;\n        }\n    }\n}\n\n::ng-deep .update-athleteheightfeet-popover {\n    --width: 100%;\t\n    --max-width: 287px;\n    .popover-viewport.sc-ion-popover-ios{\n        overflow-y: auto;\n    }\n    \n    ion-item{\n        --inner-border-width: 0;\n        --background: #ffffff;\n        background: #ffffff;\n        color: #000000;\n        font-size: 13px !important;\n        height: 36px;\n        --background-focused-opacity: 0.08 !important;\n        --background-hover-opacity: 0.08 !important;\n\n        ion-label{\n            color: #000000 !important;\n        }\n        ion-radio{\n            --color-checked:#be1e2d!important;\n        }\n    }\n}\n\n\n::ng-deep .training-center-popover {\n    --width: 100%;\t\n    --max-width: 587px;\n    .popover-viewport.sc-ion-popover-ios{\n        overflow-y: auto;\n    }\n\n    ion-item{\n        --inner-border-width: 0;\n        --background: #ffffff;\n        background: #ffffff;\n        --color: #000000;\n        color: #000000;\n        font-size: 13px !important;\n        height: 36px;\n        --background-focused-opacity: 0.08 !important;\n        --background-hover-opacity: 0.08 !important;\n\n        ion-label{\n            color: #000000 !important;\n            --color: #000000 !important;\n        }\n        ion-radio{\n            --color-checked:#be1e2d!important;\n        }\n    } \n    \n}\n\nion-select::part(text) {\n    margin-left: 10px !important;\n}\n\nion-select{\n    padding-left: 0px !important;\n}\n\nion-select.select-text::part(text) {\n    margin-left: 10px !important;\n}\n\n.tool-bar {\n    background: #BE1E2D;\n    --background: #BE1E2D;\n    border-bottom: 2px solid #c2c2c2;\n    color:white;\n}\n\nion-modal{\n    --width: 100% !important;\n\n}\n\nion-toolbar .centerButtons button {\n    width: 35px;\n}\n\nion-toolbar .centerButtons {\n    text-align: center;\n}\n\n.cropperClose .closeIcon {\n    top: inherit !important;\n}\n\nion-button{\n    width: auto;\n    height: auto;\n    --background: transparent;\n    --box-shadow : none;\n}\n\nion-button::part(native) {\n    padding: 0px 5px !important;\n}\n\n.cropperContent ion-icon{\n   color: #fff;\n}\n\n.cropperContent img{\n   max-width: 100%;\n   max-height: 100%;\n}\n\n.toolbar-save{\n    height: 55px;\n    background-color: #222428;\n    padding: 10px 0px;\n    text-align: end;\n    min-height: 55px;\n}\n\n.toolbar-edit{\n    height: 55px;\n    padding: 5px 0px;\n    background-color: #222428;\n    text-align: center;\n    min-height: 55px;\n    //position: fixed;\n    color: #fff;\n    width: 100%;\n    bottom: 0px;\n}\n\n.toolbar-save ion-icon{\n    color: #BE1E2D!important;\n    font-weight: bold;\n    font-size: 25px!important;\n}\n.toolbar-edit ion-icon{\n    color: #fff;\n    font-weight: bold;\n    font-size: 25px!important;\n}\n\n\n\n@media screen and (max-width: 556px) {\n    ::ng-deep .update-athlete-popover {\n        --max-width:507px;\n        margin-left: 10px;\n   }\n}\n\n@media screen and (max-width: 556px) {\n    ::ng-deep .update-athleteheightfeet-popover {\n        --max-width: 252px;\n        margin-left: 8px;\n   }\n}\n\n@media screen and (max-width: 556px) {\n    ::ng-deep .training-center-popover {\n        --max-width: 507px;\n        margin-left: 10px;\n   }\n}\n\n::ng-deep .update-athlete-popovermobile {\n    transform-origin: right top !important;\n    --width: 97%;\n    --background: #ffffff;\n    .popover-viewport.sc-ion-popover-ios{\n        overflow-y: auto;\n    }\n    \n    ion-item{\n        --inner-border-width: 0;\n        --background: #ffffff;\n        background: #ffffff;\n        color: #000000;\n        font-size: 13px !important;\n        height: 36px;\n         --background-focused-opacity: 0.08 !important;\n        --background-hover-opacity: 0.08 !important;\n        ion-label{\n            color: #000000 !important;\n        }\n        ion-radio{\n            --color-checked:#be1e2d!important;\n        }\n    }\n}\n\n\n::ng-deep .training-center-popovermobile {\n    transform-origin: right top !important;\n    --width: 97%;\n    --background: #ffffff;\n    .popover-viewport.sc-ion-popover-ios{\n        overflow-y: auto;\n    }\n\n    @media screen and (device-aspect-ratio: 375/667) {\n        .popover-content{\n            top : auto !important;\n            bottom: 14% !important;\n            height: 80%;\n        }\n    }\n\n    @media screen and (device-aspect-ratio: 40/71) {\n        .popover-content{\n            top : auto !important;\n            bottom: 17% !important;\n            height: 80%;\n        }\n    }\n\n    ion-item{\n        --inner-border-width: 0;\n        --background: #ffffff;\n        background: #ffffff;\n        --color: #000000;\n        color: #000000;\n        font-size: 13px !important;\n        height: 36px;\n        --background-focused-opacity: 0.08 !important;\n        --background-hover-opacity: 0.08 !important;\n\n        ion-label{\n            color: #000000 !important;\n            --color: #000000 !important;\n        }\n        ion-radio{\n            --color-checked:#be1e2d!important;\n        }\n    } \n}\n\n.e-multiselect .e-down-icon .e-chips-close.e-close-hooker{\n\tmargin-top: -26px !important;\n    padding-left: 5px\n}\n\n.e-multi-select-wrapper .e-delim-values{\n    line-height: 30px !important;\n}\n\n.e-checkbox .e-multi-select-wrapper .e-delim-values .e-remain {\n    padding-left: 5px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
